export const MeasurementFieldTypes = ['min', 'nom', 'max', 'value', 'length', 'width', 'height'] as const;

export type MeasurementFieldType = (typeof MeasurementFieldTypes)[number];
